import { createConfirmation } from 'react-confirm'
import ArticleCenshareLanguagesResultsDialog from '../../components/dialogs/ArticleCenshareLanguagesResultsDialog'

const confirm = createConfirmation(ArticleCenshareLanguagesResultsDialog)


export default function (confirmation, options = {}) {

  if (typeof confirmation !== 'string') {
    options = { ...confirmation }
    confirmation = ''
  }

  return confirm({ confirmation, options })
}
